import { HIDE_POPUP, SHOW_POPUP, UPDATE_POPUP } from "./constants";

import { isEmpty } from "core-web/utils/object";
import produce from "immer";

// The initial state of this store.
const initialState = {
    current: [],
    data: {},
};

export default produce((state, action) => {
    switch (action.type) {
        case SHOW_POPUP: {
            const currentPopupData = state.data[action.popup] || {};
            state.current = [...state.current, action.popup];
            state.data = { ...state.data, [action.popup]: { ...currentPopupData, ...action.data } };

            break;
        }

        case HIDE_POPUP: {
            const reduceState = (stateObj, keyToRemove, uniqueIdentifier) =>
                Object.keys(stateObj).reduce((object, key) => {
                    if (key !== keyToRemove) {
                        object[key] = stateObj[key];
                    } else if (uniqueIdentifier && !stateObj[uniqueIdentifier]) {
                        delete stateObj[key][uniqueIdentifier];
                        object[key] = stateObj[key];
                    }
                    return object;
                }, {});

            state.data =
                action.popup && state.data ? reduceState(state.data, action.popup, action.uniqueIdentifier) : {};

            if (!action.uniqueIdentifier || isEmpty(state.data[action.popup] || {})) {
                state.current = state.current.filter((item) => item !== action.popup && action.popup);
            }

            break;
        }

        case UPDATE_POPUP: {
            state.data = { ...state.data, [action.popup]: action.data };

            break;
        }
        default:
            break;
    }
}, initialState);
